import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import RegisteredInput from '@app/common/hook-form/registered-input';
import RegisteredDatePicker from '@app/common/hook-form/registered-date-picker';
import { Required } from '@app/common/form/important-asterisk';
import { localDateString } from '@app/common/dates/format';
export default function AutomationTokenEditFields({ disabled }) {
    const { control } = useFormContext();
    const today = useMemo(localDateString, []);
    return (_jsxs(_Fragment, { children: [_jsx(RegisteredInput, { control: control, disabled: disabled, name: "clientId", label: Required('Token name'), autoComplete: "off" }), _jsx(RegisteredDatePicker, { control: control, name: "expireDate", label: "Expiry date", disabled: disabled, minDate: today })] }));
}
